import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../WorkoutTemplateBuilder'

export default function ExerciseNoteInputBox({ phaseIndex, exercise, exerciseIndex }) {
    const { mode, mutateExercise } = useContext(WorkoutTemplateBuilderContext)

    switch (mode) {
        // Edit mode
        case 'edit':
            return (
                <textarea
                    type="text"
                    name="exerciseNote"
                    id="exerciseNote"
                    className="h-6 block bg-gray-50 w-full resize-y px-2 py-1 border-y border-stone-400 text-xs"
                    placeholder={'Exercise Note..'}
                    value={exercise.note}
                    onChange={(event) => mutateExercise('change-exercise-note', phaseIndex, exerciseIndex, null, event.target.value)}
                    disabled={false}
                />
            )

        // View mode
        case 'view':
            // If the phase note is not empty
            if (exercise.note !== undefined && exercise.note !== null && exercise.note !== '') {
                return (
                    <textarea
                        type="text"
                        name="exerciseNote"
                        id="exerciseNote"
                        className="h-6 block bg-gray-50 w-full resize-y px-2 py-1 border-t border-stone-400 text-xs"
                        placeholder={'Exercise Note..'}
                        value={exercise.note}
                        onChange={(event) => mutateExercise('change-exercise-note', phaseIndex, exerciseIndex, null, event.target.value)}
                        disabled={false}
                    />
                )
            }

            break

        // Error Message
        default:
            console.error(mode + ' is not a valid mode!!')
    }
}
